import { Directive, HostBinding, Input } from "@angular/core";

@Directive({
    selector: "[appLoadingTextSkeleton]",
    standalone: false
})
export class LoadingTextSkeletonDirective {
  @HostBinding("class.appLoadingTextSkeleton") @Input() appLoadingTextSkeleton =
    true;
}
